import { Injectable } from '@angular/core';
import { MCSGDSModel } from './mcs-gds.model';
import { ConfigurationTemplate } from '../wizard-model.interface';

@Injectable()
export class MCSModel extends MCSGDSModel {
  public readonly type = "MCS";

  protected createConfig(): ConfigurationTemplate {
    return {
      id: "create-project-mcs",
      type: 'type',
      imageUrl: `ng-assets/img/projecttypes/mcs-article.webp`,
      label: `configurationCreation.type.mcs`,
      steps: [
        {
          type: "meta",
          id: "meta",
          label: "configurationCreation.progress.configuration_data",
        },
        {
          type: "mcsGds",
          id: 'mcs',
          label: 'configurationCreation.progress.select_article',
          articleType: 'MCS',
        }
      ]
    }
  }
}
